import { render, staticRenderFns } from "./Rechteck.vue?vue&type=template&id=256e3f68&"
import script from "./Rechteck.vue?vue&type=script&lang=js&"
export * from "./Rechteck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports